import { createActionGroup, emptyProps, props } from '@ngrx/store'

export const userActions = createActionGroup({
    source: 'User',
    events: {
        'Username Loaded': props<{ userName: string }>(),
        'Start Logout': emptyProps(),
        'Logout Viewer State Sent': emptyProps(),
        'Logout Finished': emptyProps(),
    },
})
